export default "__VITE_ASSET__Ctj6XwvS__"